import cls from "./MflistExcelinput.module.css";

export default function BulkInputHelpFab({ onClick }) {
  return (
    <button type="button" className={cls.helpFab} onClick={onClick} title="사용 가이드">
      ?
    </button>
  );
}

export function BulkInputHelpModal({ open, onClose, mode }) {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.55)",
        zIndex: 10002,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "65px 0 40px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: "24px 28px",
          maxWidth: 520,
          width: "94%",
          boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 12,
            right: 14,
            background: "none",
            border: "none",
            fontSize: "1.2rem",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
        <h3 style={{ margin: "0 0 12px", color: "#1b5e20" }}>동원자원 일괄입력 가이드</h3>
        {mode === "production" ? (
          <ol style={{ lineHeight: 1.9, fontSize: "0.88rem", paddingLeft: 20 }}>
            <li>엑셀 양식을 다운로드·작성 후 파일을 선택합니다.</li>
            <li><b>검증 실행</b>으로 오류·경고를 확인합니다.</li>
            <li>필요 시 <b>자동 보정</b> 후 재검증합니다.</li>
            <li>오류 0건일 때 <b>실데이터 저장</b>으로 DB 등록·문자 발송합니다.</li>
          </ol>
        ) : (
          <ol style={{ lineHeight: 1.9, fontSize: "0.88rem", paddingLeft: 20 }}>
            <li>개수·집결지·기관 분포를 설정합니다.</li>
            <li><b>훈련 데이터 생성</b> 후 검증을 연습합니다.</li>
            <li>DB 저장은 비활성 — <b>시연용 export</b>만 가능합니다.</li>
          </ol>
        )}
      </div>
    </div>
  );
}
